import type { Requests } from "../common/request.common";
import type { WhatsAppMessageResponseTypes } from "../common/response.common";
import { post } from "./common";

export const whatsAppMessage = {
    record(data: typeof Requests.WhatsAppMessage.Record.Input) {
        return post<typeof data, WhatsAppMessageResponseTypes.Record>(
            `/whatsapp-message/record`,
            data,
        );
    },
};
